"use strict";

import angular from "angular";

angular.module("nucont").config([
    "$stateProvider",
    ($stateProvider) => {
        $stateProvider.state("nucont", {
            url: "/",
            abstract: true
        });
    }
]);
